module.exports = __webpack_public_path__ + "img/eye.62517b9b.svg";